import React from 'react';
import classnames from 'classnames';
import { i18n } from '@lt/localization';
import { pluralizeHotels } from 'src/utils/pluralizeUtils';
import styles from './filtersApply.module.css';

const className = 'lt-button';

function getButtonText(fetching, count) {
  if (fetching) {
    return `${i18n.t('filters.fetching')}`;
  }
  return count
    ? `${i18n.t('filters.applyButton.show')} ${count} ${pluralizeHotels(count)}`
    : `${i18n.t('filters.applyButton.nothing')} ${pluralizeHotels(count)}`;
}

interface FiltersApplyProps {
  fetching?: boolean;
  applyFilters: () => void;
  hotelsCount: number;
}

export const FiltersApplyMobile = (props: FiltersApplyProps) => {
  const { fetching, hotelsCount, applyFilters } = props;

  const buttonText = getButtonText(fetching, hotelsCount);
  const disabled = fetching || !hotelsCount;
  const buttonClassName = classnames(styles.button, {
    [`${className} ${className}__big`]: true,
    [`${className}__white`]: !hotelsCount,
  });

  const handleClick = () => {
    applyFilters();
  };

  return (
    <div className="filters__submit">
      <button
        type="button"
        className={buttonClassName}
        onClick={handleClick}
        disabled={disabled}
      >
        {buttonText}
      </button>
    </div>
  );
};
